import { render, staticRenderFns } from "./Somos1Home.vue?vue&type=template&id=bce2037a&scoped=true"
import script from "./Somos1Home.vue?vue&type=script&lang=js"
export * from "./Somos1Home.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bce2037a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bce2037a')) {
      api.createRecord('bce2037a', component.options)
    } else {
      api.reload('bce2037a', component.options)
    }
    module.hot.accept("./Somos1Home.vue?vue&type=template&id=bce2037a&scoped=true", function () {
      api.rerender('bce2037a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/customer-insigths/components/Somos1Home.vue"
export default component.exports